import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

//this changes the name on the browser tab, not the app itself
const WindowHeader = () => {

    const location = useLocation();
    const [headerText, setHeaderText] = useState("Barreca");

    useEffect(() => {
        handleRouteChange();
    }, [location.pathname]); // Runs whenever the route changes

    const handleRouteChange = () => {
        const path = location.pathname;

        if (path.includes("admin-login")) {
            setHeaderText("Admin | Barreca");
        } else if (path.includes("login")) {
            setHeaderText("Public | Barreca");
        } else {
            setHeaderText("Barreca");
        }
    }
    return (<>
        <meta charSet="utf-8"/>
        <meta httpEquiv="Content-type" content="text/html; charset=us-ascii"/>
        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled"/>
        <meta name="viewport" content="initial-scale=1, viewport-fit=cover"/>
        <title>{headerText}</title>

        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>
        <link rel="manifest" href="/site.webmanifest"/>

        {/* Fonts */}
        <link rel="preconnect" href="https://fonts.googleapis.com"/>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous"/>
        <link
            href="https://fonts.googleapis.com/css2?family=Figtree:ital,wght@0,300..900;1,300..900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap"
            rel="stylesheet"
        />

        {/* FontAwesome
        <link rel="stylesheet" type="text/css" href="/src/styles/js/plugins/fontawesome/all.css"/>*/}
    </>);
};

export default WindowHeader;
